import { http } from "../../services/apiCommunicated/Http.interceptor";
import CorporateCommunicated from './interfaces/CorporateCommunicated';

const URL: string = '/api/v1';

export const getCorporateCommunicated = () => {
    return http.get<CorporateCommunicated[]>(`${URL}/noImage`);
}

export const getPublic = (id: string) => {
    return http.get<number>(`${URL}/Publicos/${id}`);
}

export const getByCorporateCommunicated = (id: string) => {
    return http.get<CorporateCommunicated>(`${URL}/Notificacoes/${id}`);
}

export const postCorporateCommunicated = (corporateCommunicated: CorporateCommunicated) => {
    return http.post<CorporateCommunicated>(`${URL}/Notificacoes`, corporateCommunicated);
}

export const putCorporateCommunicated = (corporateCommunicated: CorporateCommunicated) => {
    return http.put<CorporateCommunicated>(`${URL}/Notificacoes`, corporateCommunicated);
}

export const deleteCorporateCommunicated = (id: string) => {
    return http.delete<string>(`${URL}/Notificacoes/${id}`)
}